import { IconButton, Typography } from '@mui/material';
import { ComponentPropsWithoutRef, MouseEvent, ReactNode } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import theme from 'App.theme';

type Props = Omit<ComponentPropsWithoutRef<'div'>, 'title'> & {
  title: ReactNode;
  onBackClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const PageHeader = ({ title, onBackClick, children, style, ...props }: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        padding: `${theme.layout.spacing.medium} 0px`,
        gap: theme.layout.spacing.medium,
        ...style,
      }}
      {...props}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {onBackClick && (
          <IconButton color="inherit" size="small" onClick={onBackClick}>
            <ArrowBackIosIcon sx={{ fontSize: 16 }} />
          </IconButton>
        )}

        <Typography
          variant="h3"
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: theme.layout.spacing.small,
            fontWeight: 500,
            margin: 0,
          }}
        >
          {title}
        </Typography>
      </div>

      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: theme.layout.spacing.small,
        }}
      >
        {children}
      </div>
    </div>
  );
};
